import { useContext } from 'react';
import { SharedFolder } from 'types';
import FolderItemIcon from './FolderItem/FolderItemIcon';
import useStyles from './FolderItem.styles';
import { shareContext } from '../ShareContext';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import clsx from 'clsx';

type FolderItemProps = {
  folder: SharedFolder;
};

const FolderItem = ({ folder }: FolderItemProps): JSX.Element => {
  const classes = useStyles();
  const { setSelectedFolder } = useContext(shareContext);
  const isSmallScreen = useSmallDesktopScreen();
  const folderNameClassName = isSmallScreen
    ? clsx([classes.folderName, classes.folderNameSmall])
    : classes.folderName;

  return (
    <div
      className={classes.container}
      onClick={() => setSelectedFolder(folder)}
    >
      <FolderItemIcon folder={folder} />
      <div className={folderNameClassName}>{folder.name}</div>
    </div>
  );
};

export default FolderItem;
